<template>
  <div
    class="tw:my-4 tw:flex tw:justify-between cursor-pointer"
    :class="{ 'tw:mb-4': !showScimSetup }"
    @click="toggleScimSetup"
  >
    <h3 class="tw:font-bold">
      {{ $t("modals.saml_integration_modal.scim_setup") }}
    </h3>

    <div
      class="tw:transition-all tw:duration-300"
      :class="{
        'tw:rotate-180': showScimSetup,
      }"
    >
      <BaseIcon :icon="'angle-down'" />
    </div>
  </div>

  <div
    v-if="showScimSetup"
    class="tw:mb-4"
  >
    <p>
      {{ $t("modals.saml_integration_modal.scim_setup_description_a") }}
    </p>
    <p>
      {{ $t("modals.saml_integration_modal.scim_setup_description_b") }}
    </p>

    <p>{{ $t("modals.saml_integration_modal.scim_token") }}</p>
    <div class="tw:flex tw:items-center">
      <InputText
        class="tw:mr-4 tw:w-56"
        disabled
        new-design
        type="password"
        :value="samlIntegration.scimToken"
      >
        <template #append>
          <BaseButton
            :aria-label="$t('global.copy_to_clipboard')"
            class="tw:bg-denim-900! tw:hover:border-denim-900!"
            :disabled="!samlIntegration.scimToken"
            flat
            icon="copy"
            icon-class="tw:text-white tw:bg-denim-900 tw:h-full"
            icon-size="lg"
            new-design
            new-icon
            @click="copyValueToClipboard(samlIntegration.scimToken)"
          />
        </template>
      </InputText>

      <BaseButton
        :loading="isLoading"
        new-design
        @click="setScimToken"
      >
        <QIcon
          class="tw:mr-1 tw:pl-2"
          name="fa fa-arrows-rotate"
        />
        <span class="tw:pr-2">
          <strong>{{
            $t("modals.saml_integration_modal.generate_scim_token")
          }}</strong>
        </span>
      </BaseButton>
    </div>
    <div class="tw:mt-4">
      <span>
        <strong>
          {{ $t("modals.saml_integration_modal.note") }}
        </strong>
      </span>
      <span>{{ $t("modals.saml_integration_modal.scim_note") }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

import { ErrorDialog } from "shared/boot/alert";
import { $streemApiV1 } from "shared/boot/api";
import { getLocaleText } from "shared/boot/i18n";
import { BaseButton, BaseIcon, InputText } from "shared/components/base";
import useClipboard from "shared/composables/useClipboard";
import type { SamlIntegration } from "shared/resources";

const { copyToClipboard } = useClipboard();
const isLoading = ref(false);
const showScimSetup = ref(false);

const samlIntegration = defineModel<SamlIntegration>({
  required: true,
});

async function setScimToken() {
  try {
    isLoading.value = true;

    const response = await $streemApiV1.post(
      `saml_integrations/${samlIntegration.value!.id}/set_scim_token`
    );

    samlIntegration.value!.scimToken =
      response.data.saml_integration.scim_token;
  } catch (error) {
    ErrorDialog(
      getLocaleText("saml_integration.save_integration_error"),
      error
    );
  } finally {
    isLoading.value = false;
  }
}

function toggleScimSetup() {
  showScimSetup.value = !showScimSetup.value;
}

function copyValueToClipboard(value: string = " ") {
  copyToClipboard(value);
}
</script>
